import { getHeaderNavLinks } from './navLinks';
var nav = ['Home', 'Study tools', 'Post a question', 'Solve math problems', 'Visit writing center'];
var secondaryNav = ['Career'];
var userNav = ['My Account', 'Math', 'Writing', 'Help', 'Sign Out']; // TODO : To be confirmed and removed if the life header is not in use

var lifePrimaryNav = ['Money', 'Health + Wellness', 'Life Skills', 'Resources', 'About us', 'Search Chegg Life', 'Get help'];
var qnaNav = ['Join now', 'Resubscribe', 'Resume'];
var qnaUserNav = ['My Account', 'Math', 'Writing', 'Help', 'Sign Out'];
export default getHeaderNavLinks(nav, secondaryNav, userNav, lifePrimaryNav, qnaNav, qnaUserNav);